export enum CameraType {
  Context = 'context',
  LPR = 'lpr',
}
